module.exports = __webpack_public_path__ + "static/media/sound5.3d21a92c.mp3";